<template>
  <Dialog :dialog="internalDialog" @update:dialog="closeDialog">
    <template v-slot:title>
      {{ dialogTitle }}
    </template>
    <template v-slot:body>
      <v-container fluid class="pt-0">
        <v-form ref="paymentForm" v-model.trim="formValid" lazy-validation @submit.stop.prevent="submitPayment">
    <v-row>
            <v-col md="12">
              <v-layout>
  <v-flex md4 class="my-auto">
    <label for="payment-type" class="btx-label mt-2 required">Payment Type</label>
  </v-flex>
  <v-flex md8>
    <v-radio-group row hide-details v-model="payment.type">
      <template v-for="(_radio, idx) in payment_type_radio">
        <v-radio
          :id="'type-' + _radio.value"
          :key="'payment_type_' + _radio.value + '_' + idx"
          color="#0d47a1"
          :disabled="updateMode"
          :style="`border: 1px solid ${payment.type === _radio.value ? '#0d47a1' : '#dedcdc'} !important;`"
          :class="['px-2', 'py-2', 'rounded-xl', { 'blue lighten-5': payment.type === _radio.value }]"
          :value="_radio.value"
        >
          <template v-slot:label>
            <label :for="'type-' + _radio.value" class="field-label">{{ _radio.title }}</label>
          </template>
        </v-radio>
      </template>
    </v-radio-group>
  </v-flex>
</v-layout>

              <v-layout v-if="showPaidByField">
                <v-flex md4>
                  <label for="payment-paid_by" class="btx-label mt-2 required">Paid By</label>
                </v-flex>
                <v-flex md8>
                  <TextInput
                    hide-details
                    v-model="payment.paid_by"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    id="payment-paid_by"
                    placeholder="Paid By"
                    :rules="showPaidByField ? [vrules.required(payment.paid_by, 'Paid By')] : []"
                  ></TextInput>
                </v-flex>
              </v-layout>

              <v-layout v-if="showUtilityNameField">
                <v-flex md4>
                  <label for="payment-utility_name" class="btx-label mt-2 required">Name</label>
                </v-flex>
                <v-flex md8>
                  <TextInput
                    hide-details
                    v-model="payment.utility_name"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    id="payment-utility_name"
                    placeholder="Name"
                    :rules="showUtilityNameField ? [vrules.required(payment.utility_name, 'Name')] : []"
                  ></TextInput>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md4 class="my-auto">
                  <label for="amount" class="btx-label mt-2 required">Amount</label>
                </v-flex>
                <v-flex md8>
                  <CurrencyInput
                    hide-details
                    v-model="payment.amount"
                    :rules="[vrules.required(payment.amount, 'Amount')]"
                    :class="{ required: !payment.amount }"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    id="amount"
                    placeholder="Amount"
                  ></CurrencyInput>
                </v-flex>
              </v-layout>
              <!-- <p class="text-error" v-if="payment.type !== '3'">You can enter amount as 0.</p> -->


              <v-layout>
                <v-flex md4 class="my-auto">
                  <label for="payment-date" class="btx-label mt-2 required">Payment Date</label>
                </v-flex>
                <v-flex md8>
                              <DatePicker
                    clearable
                  hide-details
                    v-model="payment.date"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                    :rules="[vrules.required(payment.date, 'Payment Date')]"
                    id="payment-date"
                    placeholder="Payment Date"
                ></DatePicker>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md4>
                  <label for="payment-remark" class="btx-label mt-2">Remark</label>
                </v-flex>
                <v-flex md8>
                  <TextAreaInput
                    hide-details
                    v-model="payment.remark"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    id="payment-remark"
                    placeholder="Remark"
                    :counter-value="250"
                  ></TextAreaInput>
                </v-flex>
              </v-layout>
                </v-col>
            </v-row>
        </v-form>
      </v-container>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="white--text mr-2"
        depressed
        color="blue darken-4"
        tile
        @click="submitPayment"
      >
        Save
      </v-btn>
      <v-btn :disabled="pageLoading" depressed tile @click="closeDialog">
        Cancel
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/components/Dialog";
import DatePicker from "@/view/components/DatePicker";
import CurrencyInput from "@/view/components/CurrencyInput";
import TextAreaInput from "@/view/components/TextAreaInput";
import TextInput from "@/view/components/TextInput"; // For 'Paid By'
import { CREATE_PAYMENT, UPDATE_PAYMENT } from "@/core/lib/payment.lib";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";

export default {
  name: "CreateOrUpdatePayment",
  components: {
    Dialog,
    DatePicker,
    CurrencyInput,
    TextAreaInput,
    TextInput,
  },
  props: {
    value: { 
      type: Boolean,
      default: false,
    },
    paymentId: { 
      type: [String, Number],
      default: null,
    },
    initialData: { 
      type: Object,
      default: () => ({}),
    },
    formType: { 
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalDialog: false,
      payment: {
        type: "1",
        utility_name: null,
        paid_by: null,
        remark: null,
        date: null,
        amount: null,
			},
      formValid: true,
      pageLoading: false,
      payment_type_radio: [
        { title: "Rent", value: "1" },
        { title: "Utility", value: "2" },
        { title: "Refund", value: "3" },
        { title: "Credit", value: "4" },
      ],
     
    };
  },
  computed: {
    updateMode() {
      return !!this.paymentId;
    },
    dialogTitle() {
      let action = this.updateMode ? "Update" : "Add";
      let subject = "Payment";
      
     
      if (this.payment && this.payment.type) {
          if (this.payment.type === '1') subject = 'Rent Payment';
          else if (this.payment.type === '2') subject = 'Utility';
          else if (this.payment.type === '3') subject = 'Refund';
          else if (this.payment.type === '4') subject = 'Credit';
      } else {
          if (this.formType === "refund") {
            subject = "Refund";
          } else if (this.formType === "utility") {
            subject = "Utility";
          } else if (this.formType === "rent") {
            subject = "Rent Payment";
          }else if (this.formType === "credit") {
            subject = "Credit Payment";
          }
      }
      return `${action} ${subject}`;
    },
    showPaidByField() {
      return this.payment.type === "3" || this.payment.type === "4"; 
    },
     showUtilityNameField() {
      return this.payment.type === "2"; 
    },
  },
  watch: {
    value(newVal) {
      this.internalDialog = newVal;
      if (newVal) {
        this.initializeForm();
      }
    },
    initialData: {
      handler() {
        if (this.internalDialog) {
         this.initializeForm();
        }
      },
      deep: true,
    },
    paymentId() {
      if (this.internalDialog) {
       this.initializeForm();
      }
    },
    'payment.type'() {
        if (this.$refs.paymentForm) {
            this.$refs.paymentForm.validate();
        }
    }
  },
  methods: {
    initializeForm() {
      this.pageLoading = false;
      if (this.updateMode && this.initialData && Object.keys(this.initialData).length > 0 && this.initialData.type !== undefined) {
        this.payment = { ...this.initialData };
        
        if (this.payment.type && typeof this.payment.type !== 'string') {
            this.payment.type = String(this.payment.type);
        }
      } else {
        this.resetFormFields(); 
      }
      
      this.$nextTick(() => {
        if (this.$refs.paymentForm) {
            this.$refs.paymentForm.resetValidation();
        }
        this.formValid = true;
        });
    },
    resetFormFields() {
      let defaultType = '1';
      if (this.formType === 'refund') {
          defaultType = '3';
      } else if (this.formType === 'utility') {
          defaultType = '2';
      }
      this.payment = {
        type: defaultType,
             utility_name: null,
        paid_by: null,
        remark: null,
        date: null,
        amount: null,
      };
    },
    async submitPayment() {
      if (!this.$refs.paymentForm.validate()) {
        this.formValid = false;
        return false;
      }
      this.formValid = true;
      this.pageLoading = true;

      let apiFormType = 'payment'; 
      if (this.payment.type === '3') {
          apiFormType = 'refund';
      } else if (this.payment.type === '2') {
          apiFormType = 'utility';
      }


      try {
        if (this.updateMode) {
          await UPDATE_PAYMENT(this.paymentId, this.payment);
          this.$store.commit(SET_MESSAGE, [
            { model: true, message: `${this.capitalizeFirstLetter(apiFormType)} Updated Successfully.` },
          ]);
        } else {
          await CREATE_PAYMENT(this.payment);
          this.$store.commit(SET_MESSAGE, [
            { model: true, message: `${this.capitalizeFirstLetter(apiFormType)} Created Successfully.` },
          ]);
        }
        this.$emit("save-success");
        this.closeDialog();
      } catch (error) {
        const errorMessage = typeof error === 'string' ? error : (error?.message || "Something went wrong. Please try again later");
        this.$store.commit(SET_ERROR, [
          { model: true, message: errorMessage },
        ]);
      } finally {
        this.pageLoading = false;
      }
    },
    closeDialog() {
      this.resetFormFields();
      this.$nextTick(() => {
        if (this.$refs.paymentForm) {
          this.$refs.paymentForm.resetValidation();
        }
      });
      this.internalDialog = false;
      this.$emit("input", false); 
      this.$emit("closed");
    },
    capitalizeFirstLetter(string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  created() {
    if (typeof this.vrules === 'undefined') {
        this.vrules = {
            required: (value, fieldName) => {
                if (value === null || value === undefined || value === '') {
                    return `${fieldName || 'Field'} is required.`;
                }
                return true;
            }
        };
    }
    this.internalDialog = this.value;
    if(this.internalDialog){
        this.initializeForm();
    }
  }
};
</script>

<style scoped>
.text-error {
  color: red;
  font-size: 0.875em;
  margin-top: 4px; 
  margin-bottom: 8px;
  padding-left: 12px; 
}
.field-label {
  cursor: pointer;
}
</style>
